export const removeHTMLTagsFromText = (richText: string): string => {
    const regex = /(<([^>]+)>)/ig;
    return richText.replace(regex, "").trim();
}